export function getTurn(id) {
    let { getTurnRequest, getTurnError, getTurnResult } = this.props

    this.doAction(this.WEB_REQUEST_URL + 'get_turn', this.createBundle('get_turn', { id }, this.GET, getTurnRequest, getTurnResult, getTurnError))
}
